import React from 'react';
import PropTypes from 'prop-types';
import { BASE_URL } from '../../../../config/constants';

const Reports = ({ token }) => (
	<div className="report-container">
		<div style={{ height: '100%' }}>
			<iframe
				src={`${BASE_URL}/cgi-bin/ccreportcgi?func_type=reportmenu&w9=${token}`}
				width="100%"
				height="90%"
				name="reports"
				style={{ border: 0 }}
			/>
		</div>
	</div>
);

Reports.propTypes = {
	token: PropTypes.string.isRequired
};

export default Reports;
